import type { Map } from 'immutable'

type StateWithAiShare = { aiShare?: Map<string, unknown> }

/** The hydrated share's kind ('dream' | 'messagePair'), only when it is this share. */
const selectAiShareKind = (shareId: string) => ({ aiShare }: StateWithAiShare): string | null => {
  if (!aiShare || aiShare.get('shareId') !== shareId) return null
  const kind = aiShare.get('kind')
  return typeof kind === 'string' ? kind : null
}

export default selectAiShareKind
